/** 
* @description 数据管理的基础库 跨框架使用的 数据管理获取 
* @version 0.3.1 
* @author lengyingxin <lengyingxin8966@gmail.com> (https://github.com/LengYXin)
*/
import _isFunction from 'lodash/isFunction';
import _mapKeys from 'lodash/mapKeys';
import _isObject from 'lodash/isObject';

/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2019-08-23 11:23:50
 * @modify date 2019-08-23 11:23:50
 * @desc [工具库]
 */
var Utils =
/** @class */
function () {
  function Utils() {}
  /**
   * 转化 object 为只读
   * @static
   * @param {*} obj
   * @param {(v) => void} [set] set 触发函数
   * @memberof Utils
   */


  Utils.toReadonly = function (obj, _set) {
    if (_isObject(obj)) {
      _mapKeys(obj, function (val, key) {
        Utils.toReadonly(val, _set);
        Object.defineProperty(obj, key, {
          // writable: false,
          // configurable: false,
          get: function get() {
            return val;
          },
          set: function set(newValue) {
            if (_isFunction(_set)) {
              _set(key, newValue);
            } else {
              console.warn(" \u5C5E\u6027 \u3010 " + key + " \u3011 \u4E0D\u53EF\u53D8 \u8BF7 lodash.merge | assign ({},[\u5F53\u524D\u5C5E\u6027\u503C],newValue) \u4F7F\u7528");
            }
          }
        });
      });
    }

    return obj;
  };

  return Utils;
}();

export { Utils };
//# sourceMappingURL=utils.js.map
